export const workScheduleFeatureKey = 'workSchedule';

export type DayOfWeek =
  | 'Sunday'
  | 'Monday'
  | 'Tuesday'
  | 'Wednesday'
  | 'Thursday'
  | 'Friday'
  | 'Saturday';

export type WorkScheduleModel = {
  id: number;
  name: string;
  active: boolean;
  /** Worked days, posted in full: a day absent from the list is deleted server-side. */
  days: WorkScheduleDayModel[];
};

/** Target hours of one day of the week. A non-worked day is absent, never present with nulls. */
export type WorkScheduleDayModel = {
  id: number;
  workScheduleId: number;
  /** Serialized by name. Display order is not the enum order. */
  dayOfWeek: DayOfWeek;
  /** TimeOnly server-side, serialized "HH:mm:ss". Wall-clock time: never convert timezone. */
  startTime: string;
  /** TimeOnly server-side, serialized "HH:mm:ss". Wall-clock time: never convert timezone. */
  endTime: string;
};
